import { createSlice, createSelector } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: false,
  user: null,
  hasExpiredSubscription: false, // New flag for subscription status
  overChecks: {
    usersExceeded: false, // New flag for user limit
    mappingsExceeded: false, // New flag for mapping limit
    executionsExceeded: false,
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload.user;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.user = null;
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
    assignProject: (state, action) => {
      if (state.user && state.user.projectsAssigned) {
        state.user.projectsAssigned.push(action.payload);
      }
    },
    setSubscriptionStatus: (state, action) => {
      state.hasExpiredSubscription = action.payload;
    },
    setOverLimitChecks: (state, action) => {
      const overLimit = action.payload;
      state.overChecks.usersExceeded = overLimit.users;
      state.overChecks.mappingsExceeded = overLimit.mappings;
      state.overChecks.executionsExceeded = overLimit.executions;
    },
  },
});

// 1. Basic selector to get the company data
const selectCompanyData = (state) => state.user.user?.companyData;

// 2. Memoized selector using createSelector
export const getPlanDetails = createSelector(
  [selectCompanyData], // Input: Only look at companyData
  (companyData) => {
    // This function only runs if companyData actually changes
    if (!companyData) {
      return {
        plan: "Free",
        maxUsers: 2,
        currentUsers: 0,
      };
    }

    const { subscription } = companyData;

    return {
      plan: subscription?.plan || "Free",
      maxUsers: subscription.limits?.maxUsers || 2,
      currentUsers: subscription.usage?.usersCount || 0,
      maxMappings: subscription.limits.maxSavedMappings || 0,
      currentMappings: subscription.usage?.savedMappings || 0,
    };
  },
);

export const getOverLimitChecks = (state) => state.user.overChecks;

export const {
  login,
  logout,
  updateUser,
  assignProject,
  setSubscriptionStatus,
  setOverLimitChecks,
} = userSlice.actions;

export default userSlice.reducer;
